import {take, fork, all, call, put, takeLatest, takeEvery} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_survey_list';

function* watchList() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_LIST_REQUESTED);
        try {
            const response = yield call(api.fetchSurveyList, payload.offset, payload.limit, payload.filter, payload.sort);
            yield put(actions.surveyListSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(actions.surveyListFailure(error));
        }
    }
}

function* watchDelete() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_DELETE_REQUESTED);
        try {
            yield call(api.deleteSurvey, payload.id);
            yield put(actions.surveyDeleteSuccess(payload.id));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(actions.surveyDeleteFailure(error, payload.id));
        }
    }
}

function* deleteInstances({payload}) {
    try {
        yield call(api.deleteSurveyInstances, payload.id);
        yield put(actions.surveyDeleteInstancesSuccess(payload.id));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyDeleteInstancesFailure(error, payload.id));
    }
}

function* exportSurvey({payload}) {
    try {
        const data = yield call(api.exportSurvey, payload.id, payload.params);
        yield put(actions.surveyExportSuccess(payload.id, data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyExportFailure(error, payload.id));
    }
}

export default function* root() {
    yield all([
        fork(watchList),
        fork(watchDelete),
        takeEvery(constants.SURVEY_EXPORT_REQUESTED, exportSurvey),
        takeLatest(constants.SURVEY_DELETE_INSTANCES_REQUESTED, deleteInstances),
    ]);
}
